import { CompanyActionContext } from '../../types/CompanyActionContext';
import { CompanyData } from '../../../types/company-data';
import { LicenseUsageDetailsResponse } from '../../licensingGrid/types/licensing-grid-responses';
import { ActionEnum } from './ActionEnum';

export const ADD_PRODUCT_EVENT = 'addProductEvent';
export const CLOSE_ADD_PRODUCT_MENU_EVENT = 'closeAddProductMenuEvent';

export interface AddProductViewData {
  context: CompanyActionContext;
  company: CompanyData;
  action: ActionEnum;
  licenseUsageDetails: LicenseUsageDetailsResponse;
}
